"use client";
import React from "react";

const LeftMenuPost = ({
    selectedPostId,
    onSelectPost,
    posts,
}) => {


    return (
        <aside className="w-80 border-r border-gray-200 bg-white p-4 overflow-y-scroll" style={{maxHeight: 'calc(100vh - 68px)'}}>
            <h2 className="text-xl font-semibold mb-4 text-gray-700"> {posts && posts.length} Bài viết</h2>

            <div className="space-y-2">
                {posts && posts.map((post, index) => (
                    <button
                        key={post.id}
                        onClick={() => onSelectPost(post.id)}
                        className={`w-full text-left p-3 rounded-lg border transition-colors ${selectedPostId === post.id
                            ? "border-rose-700 bg-rose-50 text-rose-700"
                            : "border-gray-200 hover:bg-gray-50 text-gray-700"
                            }`}
                    >
                        <p className="text-sm font-medium line-clamp-2">{index + 1}. {post.title}</p>
                        <div className="flex items-center gap-2 mt-2 text-xs text-gray-500">
                            <span>{post.created}</span>
                            <span className="w-1 h-1 bg-gray-300 rounded-full"></span>
                            <span>
                                {post.replies} {post.replies === 1 ? "reply" : "replies"}
                            </span>
                        </div>
                    </button>
                ))}
            </div>
        </aside>
    );
};

export default LeftMenuPost;


// const LeftMenuPost = ({ selectedPostId, onSelectPost }) => {
//   const [selectedCategory, setSelectedCategory] = useState("energy");

//   // Sample categories
//   const categories = [
//     { id: "energy", name: "Energy Communities" },
//     { id: "solar", name: "Solar Power" },
//     { id: "wind", name: "Wind Energy" },
//     { id: "hydro", name: "Hydropower" },
//   ];

//   // Organize posts by category
//   const postsByCategory = {
//     energy: [
//       { id: "post1", title: postData.post1.title, replies: postData.post1.replies.length, date: postData.post1.date },
//       { id: "post2", title: postData.post2.title, replies: postData.post2.replies.length, date: postData.post2.date },
//       { id: "post3", title: postData.post3.title, replies: postData.post3.replies.length, date: postData.post3.date },
//       { id: "post4", title: postData.post4.title, replies: postData.post4.replies.length, date: postData.post4.date },
//     ],
//     solar: [
//       { id: "post5", title: "Solar panel efficiency comparison", replies: 3, date: "10. Oct 2023" },
//       { id: "post6", title: "DIY solar installation guide", replies: 5, date: "08. Oct 2023" },
//       { id: "post7", title: "Solar energy storage solutions", replies: 2, date: "05. Oct 2023" },
//     ],
//     wind: [
//       { id: "post8", title: "Small-scale wind turbines for homes", replies: 4, date: "12. Oct 2023" },
//       { id: "post9", title: "Wind farm development challenges", replies: 6, date: "09. Oct 2023" },
//     ],
//     hydro: [
//       { id: "post10", title: "Micro-hydro systems for local communities", replies: 1, date: "11. Oct 2023" },
//       { id: "post11", title: "Environmental impact of hydropower", replies: 8, date: "07. Oct 2023" },
//     ],
//   };

//   return (
//     <aside className="w-64 min-w-64 border-r border-gray-200 bg-white p-4 h-full overflow-y-auto">
//       <h2 className="text-xl font-semibold mb-4 text-gray-700">Categories</h2>

//       <h3 className="text-lg font-medium mb-3 text-gray-700">Posts</h3>

//       <div className="space-y-2">
//         {postsByCategory[selectedCategory]?.map((post) => (
//           <button
//             key={post.id}
//             onClick={() => onSelectPost(post.id)}
//             className={`w-full text-left p-3 rounded-lg border transition-colors ${
//               selectedPostId === post.id
//                 ? "border-rose-700 bg-rose-50 text-rose-700"
//                 : "border-gray-200 hover:bg-gray-50 text-gray-700"
//             }`}
//           >
//             <p className="text-sm font-medium line-clamp-2">{post.title}</p>
//             <div className="flex items-center gap-2 mt-2 text-xs text-gray-500">
//               <span>{post.date}</span>
//               <span className="w-1 h-1 bg-gray-300 rounded-full"></span>
//               <span>{post.replies} {post.replies === 1 ? "reply" : "replies"}</span>
//             </div>
//           </button>
//         ))}
//       </div>
//     </aside>
//   );
// };

// export default LeftMenuPost;
